import AdminDashboard from '@/views/Admin/Dashboard/Dashboard.vue';
import { Route } from '../route.model';

const adminDashboard = new Route(
  '/admin/dashboard',
  'admin_dashboard',
  AdminDashboard,
  {
    requiresAuth: true,
    superRoot: true,
    navbar: {
      name: 'Dashboard', // TODO apply i18n
      icon: 'activities'
    },
    zendesk: {
      disabled: true
    }
  }
);

export { adminDashboard };
export default adminDashboard;
